import React, {useLayoutEffect, useState, useEffect} from 'react';
import {useMediaQuery} from 'react-responsive';
import {makeStyles} from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import {FaBars} from 'react-icons/fa';
import {Box} from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogAv from './dialogAv';
import Divider from '@material-ui/core/Divider';
import {useSelector} from 'react-redux';
import {DataGrid, ptBR} from '@material-ui/data-grid';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import {ptBR as corePtBR} from '@material-ui/core/locale';
import {getAuth} from 'firebase/auth';
import AvaliationPolicy from './avaliation_policy';

const useStyles = makeStyles(theme => ({
  formControl: {
    marginLeft: 10,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
}));

const theme = createTheme(
  {
    palette: {
      primary: {main: '#06448e'},
    },
  },
  ptBR,
  corePtBR,
);

// eslint-disable-next-line react/prop-types
const Avaliacoes = ({handleToggleSidebar, handleNotiStack, handleBackDrop}) => {
  const auth = getAuth();
  const isSmall = useMediaQuery({query: '(max-width: 750.98px)'});
  const isVerySmall = useMediaQuery({query: '(max-width:450.00px)'});
  const [isLoading, setLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const classes = useStyles();
  const idstore = useSelector(state => state.setrestaurante.idstore);
  const nAv = useSelector(state => state.setrestaurante.nNotas);
  const [nota, setNota] = useState(0);
  // const [nAv90, setnAv90] = useState(0);
  const [DATA, setDATA] = useState({});
  const [isFirstOpen, setFirstOpen] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [notas, setNotas] = useState([
    {
      nota: '-',
    },
    {
      nota: 5,
    },
    {
      nota: 4,
    },
    {
      nota: 3,
    },
    {
      nota: 2,
    },
    {
      nota: 1,
    },
  ]);
  // eslint-disable-next-line no-unused-vars
  const [comments, setCommens] = useState([
    {
      option: 'Todos',
    },
    {
      option: 'Sem comentário',
    },
    {
      option: 'Com comentário',
    },
  ]);
  const [nSearch, setNsearch] = useState();
  const [comment, setComment] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [openPolicy, setOpenPolicy] = useState(false);

  const handleChange = event => {
    setNsearch(event.target.value);
  };

  const handleChange2 = event => {
    setComment(event.target.value);
  };

  const [selectedInitialDate, setSelectedInitialDate] = React.useState(
    new Date(),
  );
  const handleInitialDateChange = date => {
    setSelectedInitialDate(date);
  };

  const [selectedEndDate, setSelectedEndDate] = React.useState(new Date());
  const handleEndDateChange = date => {
    setSelectedEndDate(date);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
      scrollToTop();
    }, 1000);
  }, []);

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Button is displayed after scrolling for 500 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 50) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }
  // eslint-disable-next-line no-unused-vars
  const [width, height] = useWindowSize();

  function createData(
    npd,
    nota,
    fday,
    ntobs,
    sttav,
    _id,
    censuquest,
    censurado,
  ) {
    return {npd, nota, fday, ntobs, sttav, _id, censuquest, censurado};
  }

  const columns = [
    {
      field: 'npd',
      headerName: 'Pedido',
      width: isVerySmall || isSmall ? 150 : 180,
      editable: false,
    },
    {
      field: 'fday',
      headerName: 'Data',
      width: isVerySmall || isSmall ? 150 : 180,
      editable: false,
    },
    {
      field: 'nota',
      headerName: 'Nota',
      width: isVerySmall || isSmall ? 150 : 180,
      editable: false,
    },
    {
      field: 'fday',
      headerName: 'Data',
      width: isVerySmall || isSmall ? 150 : 180,
      editable: false,
    },
    {
      field: 'ntobs',
      headerName: 'Observação',
      width: isVerySmall || isSmall ? 150 : 180,
      editable: false,
    },
    {
      field: 'sttav',
      headerName: 'Status',
      type: 'number',
      width: isVerySmall || isSmall ? 150 : 180,
      editable: false,
      valueFormatter: params => {
        if (params.value == 0) {
          return 'Em análise';
        } else if (params.value == 1) {
          return 'Postado';
        } else if (params.value == 2) {
          return 'Revogado';
        } else {
          return 'Revogado';
        }
      },
    },
  ];

  const [rows, setRows] = useState([]);
  const [resultsSize, setResultsize] = useState(0);
  const [results, setResults] = useState([]);

  useEffect(() => {
    let map = [];
    if (results.length > 0) {
      // eslint-disable-next-line no-unused-vars
      map = results.map((item, index) => {
        return createData(
          item.npd,
          item.nota,
          item.fday,
          item.ntobs,
          item.sttav,
          item._id,
          item.censuquest,
          item.censurado,
        );
      });
    }
    setRows(map);
    setResultsize(results.length);
  }, [results]);

  useEffect(() => {
    auth.currentUser.getIdToken().then(token => {
      const pedidosrequest = new Request(
        'https://kops.apiireit.com/gateway/pedidos/get/resumeav/filter?estid=' +
          idstore +
          '&startdate=' +
          convertDate(selectedInitialDate) +
          '&enddate=' +
          convertDate(selectedEndDate) +
          '&nota=' +
          -1 +
          '&all=' +
          true +
          '&withcmt=' +
          false,
        {
          method: 'GET',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      fetch(pedidosrequest)
        .then(response => {
          if (response.status === 200) {
            handleBackDrop('', '', 200, false);
            response
              .json()
              .then(data => {
                setResults(data.pds);
                //  setnAv90(data.lastav);
                setNota(data.ntm);
                setTimeout(() => {
                  setIsSearching(false);
                  if (data.length == 0) {
                    handleNotiStack('Nenhum resultado encontrado');
                  }
                }, 1000);
              })
              .catch(error => {
                console.error(error);
              });
          } else if (response.status === 503) {
            handleBackDrop(
              'Serviço indisponível no momento',
              'O serviços para as lojas Irê it não estão disponíveis no momento. Por favor, tente novamente mais tarde',
              503,
              true,
            );
            throw new Error('Something went wrong on API server!');
          } else if (response.status === 404) {
            handleBackDrop(
              'Serviço não encontrado.',
              'Por favor, entre em contato com o nosso suporte e relate o problema.',
              404,
              true,
            );
          } else if (response.status === 401) {
            handleBackDrop(
              'Você não possui autorização ou suas credenciais expirarão.',
              'Por favor, atualize a baixa ou refaça o processo dee login.',
              401,
              true,
            );
          } else if (response.status === 400) {
            handleBackDrop(
              'Requisição inválida.',
              'Confira se todos os campos estão preenchidos corretamente.',
              400,
              true,
            );
          } else if (response.status === 500) {
            handleBackDrop(
              'Nosso servidor está passando por irregularidades.',
              'Estamos trabalhado para resolver o mais rápido possível.',
              500,
              true,
            );
          }
        })
        .catch(error => {
          handleBackDrop(
            'Nosso servidor está passando por irregularidades.',
            'Estamos trabalhado para resolver o mais rápido possível.',
            500,
            true,
          );
          console.error(error);
        });
    });
  }, []);

  const handleOnCellClick = params => {
    let currentitem = {};
    currentitem = results
      .filter(orders => orders._id == params.id)
      .map(item => {
        return item;
      });
    setDATA(currentitem[0]);
    setOpenDialog(true);
  };

  function convertDate(str) {
    var date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join('/');
  }

  function onSearching() {
    setFirstOpen(false);
    setIsSearching(true);
    setResults([]);
    let all = false;
    let withcomment = false;
    if (comment == 'Todos' || comment == undefined) {
      all = true;
    } else if (comment == 'Com comentário') {
      withcomment = true;
    } else if (comment == 'Sem comentário') {
      withcomment = false;
    }

    let nt = 5;
    if (nSearch == undefined || nSearch == '-') {
      nt = -1;
    } else {
      nt = nSearch;
    }
    auth.currentUser.getIdToken().then(token => {
      const pedidosrequest = new Request(
        'https://kops.apiireit.com/gateway/pedidos/get/resumeav/filter?estid=' +
          idstore +
          '&startdate=' +
          convertDate(selectedInitialDate) +
          '&enddate=' +
          convertDate(selectedEndDate) +
          '&nota=' +
          nt +
          '&all=' +
          all +
          '&withcmt=' +
          withcomment,
        {
          method: 'GET',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      fetch(pedidosrequest)
        .then(response => {
          if (response.status === 200) {
            handleBackDrop('', '', 200, false);
            response
              .json()
              .then(data => {
                setResults(data.pds);
                setTimeout(() => {
                  setIsSearching(false);
                  if (data.length == 0) {
                    handleNotiStack('Nenhum resultado encontrado');
                  }
                }, 1000);
              })
              .catch(error => {
                console.error(error);
              });
          } else if (response.status === 503) {
            handleBackDrop(
              'Serviço indisponível no momento',
              'O serviços para as lojas Irê it não estão disponíveis no momento. Por favor, tente novamente mais tarde',
              503,
              true,
            );
            throw new Error('Something went wrong on API server!');
          } else if (response.status === 404) {
            handleBackDrop(
              'Serviço não encontrado.',
              'Por favor, entre em contato com o nosso suporte e relate o problema.',
              404,
              true,
            );
          } else if (response.status === 401) {
            handleBackDrop(
              'Você não possui autorização ou suas credenciais expirarão.',
              'Por favor, atualize a baixa ou refaça o processo dee login.',
              401,
              true,
            );
          } else if (response.status === 400) {
            handleBackDrop(
              'Requisição inválida.',
              'Confira se todos os campos estão preenchidos corretamente.',
              400,
              true,
            );
          } else if (response.status === 500) {
            handleBackDrop(
              'Nosso servidor está passando por irregularidades.',
              'Estamos trabalhado para resolver o mais rápido possível.',
              500,
              true,
            );
          }
        })
        .catch(error => {
          handleBackDrop(
            'Nosso servidor está passando por irregularidades.',
            'Estamos trabalhado para resolver o mais rápido possível.',
            500,
            true,
          );
          console.error(error);
        });
    });
  }

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            height: height,
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div>
          {isVisible ? (
            <Fab
              onClick={() => scrollToTop()}
              style={{position: 'fixed', bottom: 20, right: 20, zIndex: 2}}
              size={'small'}
              color="primary"
              aria-label="add"
            >
              <ArrowUpwardIcon />
            </Fab>
          ) : null}
          <div
            style={{marginLeft: 10, marginTop: 10}}
            className="btn-toggle"
            onClick={() => handleToggleSidebar(true)}
          >
            <FaBars />
          </div>
          {isVerySmall ? (
            <div>
              <h1 style={{marginLeft: 10, marginBottom: 5, color: '#393939'}}>
                Avaliações{' '}
              </h1>
              <div>
                <Box
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    borderRadius: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                  boxShadow={3}
                >
                  <div>
                    <p>Nota média</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: -20,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 20,
                          fontWeight: 'bold',
                          color: '#393939',
                        }}
                      >
                        {nota.toFixed(2)}
                      </p>
                      <StarIcon
                        style={{
                          fontSize: 20,
                          color: '#FFFF00',
                          marginLeft: 3,
                        }}
                      />
                    </div>
                  </div>
                  <Divider variant="middle" />
                  {/*
<div style={{marginLeft: 0}}>
                    <p>Últimos 60 dias</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: -20,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 20,
                          fontWeight: 'bold',
                          color: '#393939',
                        }}
                      >
                        {nAv90}
                      </p>
                      {nAv90 == 1 ? (
                        <p
                          style={{
                            fontSize: 14,
                            color: '#393939',
                            marginLeft: 3,
                          }}
                        >
                          avaliação postada
                        </p>
                      ) : (
                        <p
                          style={{
                            fontSize: 14,
                            color: '#393939',
                            marginLeft: 3,
                          }}
                        >
                          avaliações postadas
                        </p>
                      )}
                    </div>
                  </div>
                    */}

                  <Divider variant="middle" />
                  <div style={{marginLeft: 0}}>
                    <p>Total</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: -20,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 20,
                          fontWeight: 'bold',
                          color: '#393939',
                        }}
                      >
                        {nAv}
                      </p>
                      {nAv == 1 ? (
                        <p
                          style={{
                            fontSize: 14,
                            color: '#393939',
                            marginLeft: 3,
                          }}
                        >
                          avaliação aprovada
                        </p>
                      ) : (
                        <p
                          style={{
                            fontSize: 14,
                            color: '#393939',
                            marginLeft: 3,
                          }}
                        >
                          avaliações aprovadas
                        </p>
                      )}
                    </div>
                  </div>
                </Box>
              </div>
              <div
                style={{
                  marginTop: 15,
                  marginLeft: 10,
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <p1
                  style={{
                    fontSize: 18,
                    fontWeight: 'bold',
                    color: '#393939',
                    alignItems: 'center',
                  }}
                >
                  Buscar avaliações
                </p1>
                <Button
                  style={{marginLeft: -3, marginTop: 0}}
                  variant="text"
                  size={'small'}
                  color="primary"
                  onClick={() => setOpenPolicy(true)}
                >
                  Política de avaliação
                </Button>
              </div>
              <div style={{marginTop: 0, marginLeft: 10}}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '90%',
                  }}
                >
                  <FormControl>
                    <InputLabel
                      style={{fontSize: 14}}
                      id="demo-simple-select-label"
                    >
                      Avaliação
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={nSearch}
                      onChange={handleChange}
                      style={{marginTop: 14}}
                    >
                      {(Array.isArray(notas)
                        ? notas.map(({nota}) => [nota])
                        : Object.entries(notas)
                      ).map(([title]) => {
                        return (
                          <MenuItem
                            style={{fontSize: 14}}
                            key={title}
                            value={title}
                          >
                            {title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '90%',
                  }}
                >
                  <FormControl>
                    <InputLabel
                      style={{fontSize: 14}}
                      id="demo-simple-select-label"
                    >
                      Comentários
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={nSearch}
                      onChange={handleChange2}
                      style={{marginTop: 14}}
                    >
                      {(Array.isArray(comments)
                        ? comments.map(({option}) => [option])
                        : Object.entries(comments)
                      ).map(([title]) => {
                        return (
                          <MenuItem
                            style={{fontSize: 14}}
                            key={title}
                            value={title}
                          >
                            {title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                <div style={{marginTop: 5, width: '90%'}}>
                  <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    <MuiPickersUtilsProvider
                      locale={deLocale}
                      utils={DateFnsUtils}
                    >
                      <KeyboardDatePicker
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="date-picker-dialog1"
                        label="Buscar avaliações de"
                        value={selectedInitialDate}
                        onChange={handleInitialDateChange}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        InputProps={{
                          style: {
                            fontSize: 14,
                            height: 44,
                          },
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div style={{marginLeft: 0, marginTop: 0}}>
                    <MuiPickersUtilsProvider
                      locale={deLocale}
                      utils={DateFnsUtils}
                    >
                      <KeyboardDatePicker
                        style={{marginLeft: 0}}
                        margin="normal"
                        id="date-picker-dialog2"
                        label="até"
                        format="dd/MM/yyyy"
                        minDate={selectedInitialDate}
                        minDateMessage={'Deve ser depois da data inicial'}
                        value={selectedEndDate}
                        onChange={handleEndDateChange}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        InputProps={{
                          style: {
                            fontSize: 14,
                            height: 44,
                          },
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
                <div>
                  <Button
                    style={{marginLeft: 0, marginTop: 15}}
                    variant="contained"
                    size={'medium'}
                    color="primary"
                    onClick={() => onSearching()}
                  >
                    Buscar
                  </Button>
                </div>
                {isSearching ? (
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: height / 2,
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <div style={{marginLeft: 0, marginRight: 20, marginTop: 30}}>
                    {isFirstOpen ? (
                      <p
                        style={{
                          fontWeight: 'bold',
                          color: '#393939',
                          fontSize: 18,
                          marginBottom: 80,
                        }}
                      >
                        Adicione as informações que você deseja e clique em
                        buscar.
                      </p>
                    ) : resultsSize === 0 ? (
                      <p
                        style={{
                          fontWeight: 'bold',
                          color: '#393939',
                          fontSize: 18,
                          marginBottom: 80,
                        }}
                      >
                        Nenhuma avaliação encontrada.
                      </p>
                    ) : (
                      <div>
                        {resultsSize === 1 ? (
                          <p
                            style={{
                              fontWeight: 'bold',
                              color: '#393939',
                              fontSize: 18,
                            }}
                          >
                            {resultsSize} Avaliação encontrada
                          </p>
                        ) : (
                          <p
                            style={{
                              fontWeight: 'bold',
                              color: '#393939',
                              fontSize: 18,
                            }}
                          >
                            {resultsSize} Avaliações encontradas
                          </p>
                        )}

                        <p
                          style={{
                            color: '#393939',
                            fontSize: 14,
                          }}
                        >
                          A Irê it posta as avaliações após 7 dias
                        </p>
                        <div
                          style={{height: 400, width: '100%', marginBottom: 80}}
                        >
                          <ThemeProvider theme={theme}>
                            <DataGrid
                              sx={{
                                boxShadow: 2,
                                border: 2,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                  color: 'primary',
                                },
                              }}
                              onCellClick={handleOnCellClick}
                              rows={rows}
                              columns={columns}
                              pageSize={20}
                              disableSelectionOnClick
                              getRowId={row => row._id}
                            />
                          </ThemeProvider>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : isSmall ? (
            <div>
              <h1 style={{marginLeft: 10, marginBottom: 5, color: '#393939'}}>
                Avaliações{' '}
              </h1>
              <div>
                <Box
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    borderRadius: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                  boxShadow={3}
                >
                  <div>
                    <p>Nota média das avaliações postadas</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: -20,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 20,
                          fontWeight: 'bold',
                          color: '#393939',
                        }}
                      >
                        {nota.toFixed(2)}
                      </p>
                      <StarIcon
                        style={{
                          fontSize: 20,
                          color: '#FFFF00',
                          marginLeft: 3,
                        }}
                      />
                    </div>
                  </div>
                  {/*
                     <Divider variant="middle" />
                  <div style={{marginLeft: 0}}>
                    <p>Últimos 60 dias</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: -20,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 20,
                          fontWeight: 'bold',
                          color: '#393939',
                        }}
                      >
                        {nAv90}
                      </p>
                      <p
                        style={{
                          fontSize: 14,
                          color: '#393939',
                          marginLeft: 3,
                        }}
                      >
                        avaliações
                      </p>
                    </div>
                  </div>
                    */}

                  <Divider variant="middle" />
                  <div style={{marginLeft: 0}}>
                    <p>Total</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: -20,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 20,
                          fontWeight: 'bold',
                          color: '#393939',
                        }}
                      >
                        {nAv}
                      </p>
                      <p
                        style={{
                          fontSize: 14,
                          color: '#393939',
                          marginLeft: 3,
                        }}
                      >
                        avaliações
                      </p>
                    </div>
                  </div>
                </Box>
              </div>
              <div
                style={{
                  marginTop: 15,
                  marginLeft: 10,
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <p1
                  style={{
                    fontSize: 18,
                    fontWeight: 'bold',
                    color: '#393939',
                    alignItems: 'center',
                  }}
                >
                  Buscar avaliações
                </p1>
                <Button
                  style={{marginLeft: -3, marginTop: 0}}
                  variant="text"
                  size={'small'}
                  color="primary"
                  onClick={() => setOpenPolicy(true)}
                >
                  Política de avaliação
                </Button>
              </div>
              <div style={{marginTop: 0, marginLeft: 10}}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '90%',
                  }}
                >
                  <FormControl>
                    <InputLabel
                      style={{fontSize: 14}}
                      id="demo-simple-select-label"
                    >
                      Avaliação
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={nSearch}
                      onChange={handleChange}
                      style={{marginTop: 14}}
                    >
                      {(Array.isArray(notas)
                        ? notas.map(({nota}) => [nota])
                        : Object.entries(notas)
                      ).map(([title]) => {
                        return (
                          <MenuItem
                            style={{fontSize: 14}}
                            key={title}
                            value={title}
                          >
                            {title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '90%',
                  }}
                >
                  <FormControl>
                    <InputLabel
                      style={{fontSize: 14}}
                      id="demo-simple-select-label"
                    >
                      Comentários
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={nSearch}
                      onChange={handleChange2}
                      style={{marginTop: 14}}
                    >
                      {(Array.isArray(comments)
                        ? comments.map(({option}) => [option])
                        : Object.entries(comments)
                      ).map(([title]) => {
                        return (
                          <MenuItem
                            style={{fontSize: 14}}
                            key={title}
                            value={title}
                          >
                            {title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                <div style={{marginTop: 5, width: '90%'}}>
                  <div style={{marginLeft: 0}}>
                    <MuiPickersUtilsProvider
                      locale={deLocale}
                      utils={DateFnsUtils}
                    >
                      <KeyboardDatePicker
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="date-picker-dialog1"
                        label="Buscar avaliações de"
                        value={selectedInitialDate}
                        onChange={handleInitialDateChange}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        InputProps={{
                          style: {
                            fontSize: 14,
                            height: 44,
                          },
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div style={{marginLeft: 0, marginTop: 0}}>
                    <MuiPickersUtilsProvider
                      locale={deLocale}
                      utils={DateFnsUtils}
                    >
                      <KeyboardDatePicker
                        style={{marginLeft: 0}}
                        margin="normal"
                        id="date-picker-dialog2"
                        label="até"
                        format="dd/MM/yyyy"
                        minDate={selectedInitialDate}
                        minDateMessage={'Deve ser depois da data inicial'}
                        value={selectedEndDate}
                        onChange={handleEndDateChange}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        InputProps={{
                          style: {
                            fontSize: 14,
                            height: 44,
                          },
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
                <div>
                  <Button
                    style={{marginLeft: 0, marginTop: 15}}
                    variant="contained"
                    size={'medium'}
                    color="primary"
                    onClick={() => onSearching()}
                  >
                    Buscar
                  </Button>
                </div>
                {isSearching ? (
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: height / 2,
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <div style={{marginLeft: 0, marginRight: 20, marginTop: 30}}>
                    {isFirstOpen ? (
                      <p
                        style={{
                          fontWeight: 'bold',
                          color: '#393939',
                          fontSize: 18,
                          marginBottom: 80,
                        }}
                      >
                        Adicione as informações que você deseja e clique em
                        buscar.
                      </p>
                    ) : resultsSize === 0 ? (
                      <p
                        style={{
                          fontWeight: 'bold',
                          color: '#393939',
                          fontSize: 18,
                        }}
                      >
                        Nenhuma avaliação encontrada
                      </p>
                    ) : (
                      <div>
                        {resultsSize === 1 ? (
                          <p
                            style={{
                              fontWeight: 'bold',
                              color: '#393939',
                              fontSize: 18,
                            }}
                          >
                            {resultsSize} Avaliação encontrada
                          </p>
                        ) : (
                          <p
                            style={{
                              fontWeight: 'bold',
                              color: '#393939',
                              fontSize: 18,
                            }}
                          >
                            {resultsSize} Avaliações encontradas
                          </p>
                        )}

                        <p
                          style={{
                            color: '#393939',
                            fontSize: 14,
                          }}
                        >
                          A Irê it posta as avaliações após 7 dias
                        </p>
                        <div
                          style={{height: 400, width: '100%', marginBottom: 80}}
                        >
                          <ThemeProvider theme={theme}>
                            <DataGrid
                              onCellClick={handleOnCellClick}
                              rows={rows}
                              columns={columns}
                              pageSize={20}
                              disableSelectionOnClick
                              getRowId={row => row._id}
                            />
                          </ThemeProvider>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <h1 style={{marginLeft: 10, marginBottom: 5, color: '#393939'}}>
                Avaliações{' '}
              </h1>
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <div style={{width: '100%'}}>
                  <Box
                    style={{
                      marginLeft: 10,
                      marginRight: 10,
                      borderRadius: 3,
                      display: 'flex',
                      paddingLeft: 20,
                      paddingRight: 20,
                    }}
                    boxShadow={3}
                  >
                    <div>
                      <p>Nota média</p>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginTop: -20,
                        }}
                      >
                        <p
                          style={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            color: '#393939',
                          }}
                        >
                          {nota.toFixed(2)}
                        </p>
                        <StarIcon
                          style={{
                            fontSize: 20,
                            color: '#FFFF00',
                            marginLeft: 3,
                          }}
                        />
                      </div>
                    </div>
                    {/*
                       <div style={{marginLeft: 30}}>
                      <p>Últimos 60 dias</p>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginTop: -20,
                        }}
                      >
                        <p
                          style={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            color: '#393939',
                          }}
                        >
                          {nAv90}
                        </p>
                        <p
                          style={{
                            fontSize: 14,
                            color: '#393939',
                            marginLeft: 3,
                          }}
                        >
                          avaliações
                        </p>
                      </div>
                    </div>
                      */}

                    <div style={{marginLeft: 30}}>
                      <p>Total</p>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginTop: -20,
                        }}
                      >
                        <p
                          style={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            color: '#393939',
                          }}
                        >
                          {nAv}
                        </p>
                        <p
                          style={{
                            fontSize: 14,
                            color: '#393939',
                            marginLeft: 3,
                          }}
                        >
                          avaliações
                        </p>
                      </div>
                    </div>
                  </Box>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginLeft: 20,
                      marginRight: 20,
                      marginTop: 15,
                    }}
                  >
                    <p1
                      style={{
                        fontSize: 18,
                        fontWeight: 'bold',
                        color: '#393939',
                        alignItems: 'center',
                      }}
                    >
                      Buscar avaliações
                    </p1>
                    <Button
                      style={{marginLeft: 10, marginTop: 0}}
                      variant="text"
                      size={'small'}
                      color="primary"
                      onClick={() => setOpenPolicy(true)}
                    >
                      Política de avaliação
                    </Button>
                  </div>
                  <div
                    style={{
                      marginLeft: 20,
                      marginRight: 20,
                      display: 'flex',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        marginBottom: 10,
                        marginRight: 10,
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: 80,
                        }}
                      >
                        <FormControl>
                          <InputLabel
                            style={{fontSize: 14}}
                            id="demo-simple-select-label"
                          >
                            Avaliação
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={nSearch}
                            onChange={handleChange}
                            style={{marginTop: 14}}
                          >
                            {(Array.isArray(notas)
                              ? notas.map(({nota}) => [nota])
                              : Object.entries(notas)
                            ).map(([title]) => {
                              return (
                                <MenuItem
                                  style={{fontSize: 14}}
                                  key={title}
                                  value={title}
                                >
                                  {title}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: 170,
                        }}
                      >
                        <FormControl className={classes.formControl}>
                          <InputLabel
                            style={{fontSize: 14}}
                            id="demo-simple-select-label"
                          >
                            Comentários
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={nSearch}
                            onChange={handleChange2}
                            style={{marginTop: 14}}
                          >
                            {(Array.isArray(comments)
                              ? comments.map(({option}) => [option])
                              : Object.entries(comments)
                            ).map(([title]) => {
                              return (
                                <MenuItem
                                  style={{fontSize: 14}}
                                  key={title}
                                  value={title}
                                >
                                  {title}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div style={{display: 'flex'}}>
                      <div style={{marginLeft: 0, marginTop: -18}}>
                        <MuiPickersUtilsProvider
                          locale={deLocale}
                          utils={DateFnsUtils}
                        >
                          <KeyboardDatePicker
                            format="dd/MM/yyyy"
                            margin="normal"
                            id="date-picker-dialog1"
                            label="Buscar avaliações de"
                            value={selectedInitialDate}
                            onChange={handleInitialDateChange}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                      <div style={{marginLeft: 0, marginTop: -18}}>
                        <MuiPickersUtilsProvider
                          locale={deLocale}
                          utils={DateFnsUtils}
                        >
                          <KeyboardDatePicker
                            style={{marginLeft: 20}}
                            margin="normal"
                            id="date-picker-dialog2"
                            label="até"
                            format="dd/MM/yyyy"
                            minDate={selectedInitialDate}
                            minDateMessage={'Deve ser depois da data inicial'}
                            value={selectedEndDate}
                            onChange={handleEndDateChange}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                  </div>
                  <div>
                    <Button
                      style={{marginLeft: 15, marginTop: 15}}
                      variant="contained"
                      size={'medium'}
                      color="primary"
                      onClick={() => onSearching()}
                    >
                      Buscar
                    </Button>
                  </div>
                  {isSearching ? (
                    <div
                      style={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: height / 2,
                      }}
                    >
                      <CircularProgress />
                    </div>
                  ) : (
                    <div
                      style={{marginLeft: 20, marginRight: 20, marginTop: 30}}
                    >
                      {isFirstOpen ? (
                        <p
                          style={{
                            fontWeight: 'bold',
                            color: '#393939',
                            fontSize: 18,
                            marginBottom: 80,
                          }}
                        >
                          Adicione as informações que você deseja e clique em
                          buscar.
                        </p>
                      ) : resultsSize === 0 ? (
                        <p
                          style={{
                            fontWeight: 'bold',
                            color: '#393939',
                            fontSize: 18,
                          }}
                        >
                          Nenhuma avaliação encontrada
                        </p>
                      ) : (
                        <div>
                          {resultsSize === 1 ? (
                            <p
                              style={{
                                fontWeight: 'bold',
                                color: '#393939',
                                fontSize: 18,
                              }}
                            >
                              {resultsSize} Avaliação encontrada
                            </p>
                          ) : (
                            <p
                              style={{
                                fontWeight: 'bold',
                                color: '#393939',
                                fontSize: 18,
                              }}
                            >
                              {resultsSize} Avaliações encontradas
                            </p>
                          )}

                          <p
                            style={{
                              color: '#393939',
                              fontSize: 14,
                            }}
                          >
                            A Irê it posta as avaliações após 7 dias
                          </p>
                          <div
                            style={{
                              height: 300,
                              width: '100%',
                            }}
                          >
                            <ThemeProvider theme={theme}>
                              <DataGrid
                                onCellClick={handleOnCellClick}
                                rows={rows}
                                columns={columns}
                                pageSize={20}
                                disableSelectionOnClick
                                getRowId={row => row._id}
                              />
                            </ThemeProvider>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <DialogAv
            bopen={openDialog}
            handleClose={() => setOpenDialog(false)}
            handleNotiStack={handleNotiStack}
            DATA={DATA}
            setDATA={setDATA}
            style={{
              top: 0,
              position: 'absolute',
              zIndex: 3,
            }}
          />
        </div>
      )}
      <AvaliationPolicy
        bopen={openPolicy}
        handleClose={() => setOpenPolicy(false)}
      />
    </div>
  );
};

export default Avaliacoes;
